import React from 'react'
import Label from "components/general/Label"
import { ColumnRank, ColumnName, ColumnNoc, ColumnResult, ColumnExpander, ColumnQualification, ColumnStartOrder } from "components/common/TableColumns"

export default function TableColumns() {
  return (
    [
      ColumnStartOrder({}),
      ColumnRank({}),
      ColumnTarget({}),
      ColumnNoc({}),
      ColumnName({}),
      ColumnTens({}),
      ColumnXs({}),
      ColumnResult({ label: 'HeaderScore' }),
      ColumnRecords({}),
      ColumnQualification({}),
      ColumnExpander({ type: 'alwaysTrue' })
    ]
  )
}

function ColumnTarget({
  disableSort = false,
  className = 'text-end',
  headerClassName = 'text-end w-10',
  label = 'HeaderTarget'
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'startSortOrder',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Target',
      Cell: (props) => (
        <>
          {props.cell.row.original.eventUnitEntries.find(row => row.eue_code === 'TARGET').eue_value}
          {props.cell.row.original.eventUnitEntries.find(row => row.eue_code === 'TARGET_POS').eue_value}
        </>
      )
    }
  )
}

function ColumnTens({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-10',
  label = 'HeaderTens'
}) {
  return (
    {
      Header: <Label data={label} />,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Tens',
      Cell: (props) => (
        <>
          {props?.cell?.row?.original?.extendedResults?.find(row => row.er_code === 'TEN_NUM')?.er_value}
        </>
      )
    }
  )
}

function ColumnXs({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-10',
  label = 'HeaderXs'
}) {
  return (
    {
      Header: <Label data={label} />,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Xs',
      Cell: (props) => (
        <>
          {props?.cell?.row?.original?.extendedResults?.find(row => row.er_code === 'XS_NUM')?.er_value}
        </>
      )
    }
  )
}

function ColumnRecords({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-5 align-middle',
  remove = false,
  label = ''
}) {
  return (
    {
      //Header: 'Ghost',
      Header: <Label data={label} />,
      remove: remove,
      accessor: 'recordIndicators',// accessor is the "key" in the data 
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      id: 'Records',
      Cell: (props) => (
        <>
          {props?.cell?.row?.original?.extendedResults?.find(row => row.er_code === 'TOSS')?.er_value === 'Y' ? <span className='mx-1'><Label data="LabelToss" /></span> : ''}

          {props?.cell?.row?.original?.extendedResults?.find(row => row.er_code === 'TIED')?.er_value === 'Y' ? <span className=' mx-1'><Label data="LabelTied" /></span> : ''}

          {props.cell.row.original.recordIndicators
            ? props.cell.row.original.recordIndicators.filter(row => row.ri_order === 1).map((val) => {
              return ((val.ri_equalled === 'Y' ? '=' : '') + val.ri_recordtype)
            })
            : ''
          }
        </>
      )
    }
  )
}